<div class="management-container-wrapper">

  <div class="management-container">
    <h3>Gestión de Categorías</h3>
    <p>Añade nuevas categorías o arrastra las existentes para reordenar su jerarquía.</p>

    <div class="add-item-form">
      <input
        type="text"
        [(ngModel)]="newCategoryName"
        placeholder="Nombre de la nueva categoría"
        (keyup.enter)="addCategory()">
      <button (click)="addCategory()" class="add-button" [disabled]="!newCategoryName.trim()">Añadir</button>
    </div>

    <div cdkDropList class="item-list" (cdkDropListDropped)="onDrop($event)">
      @for (category of categories; track category.id || category.name; let i = $index) {
        <div class="item-card" cdkDrag>
          <div class="drag-handle" cdkDragHandle title="Arrastrar para reordenar">⠿</div>
          <input type="text" [(ngModel)]="category.name" class="item-name-input" placeholder="Nombre de categoría">
<!--
          TODO: Barajar la implementación de eliminar.
          <button class="delete-button" (click)="removeCategory(i)" title="Eliminar categoría">×</button>
-->
        </div>
      }
    </div>

    <div class="actions">
      <button (click)="saveChanges()" class="primary" [disabled]="isLoading">Guardar Cambios</button>
    </div>
  </div>



</div>
